var map = {
	"./BrutalType-Bold/BrutalType-Bold.woff": 1026,
	"./BrutalType-Medium/BrutalType-Medium.woff": 1027,
	"./BrutalType-Regular/BrutalType-Regular.woff": 1028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1025;